<template>
  <path
    d="M18 2.00024H10.83C10.3 2.00024 9.79 2.21024 9.41 2.59024L4.6 7.42024C4.23 7.79024 4.02 8.30024 4.02 8.82024L4 20.0002C4 21.1002 4.9 22.0002 6 22.0002H18C19.1 22.0002 20 21.1002 20 20.0002V4.00024C20 2.90024 19.1 2.00024 18 2.00024ZM13 17.0002H11V15.0002H13V17.0002ZM12 13.0002C11.45 13.0002 11 12.5502 11 12.0002V9.00024C11 8.45024 11.45 8.00024 12 8.00024C12.55 8.00024 13 8.45024 13 9.00024V12.0002C13 12.5502 12.55 13.0002 12 13.0002Z"
  />
</template>
